module.exports = __webpack_public_path__ + "1_0_63/img/sign.b8c28cae.svg";